"use client";

import React from "react";
import s from "../styles";

/**
 * 備考コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Object} props.form - フォームオブジェクト
 * @param {Object} props.formProps - フォームプロパティ
 * @param {string} props.mode - "view"（参照モード）または"edit"（編集モード）
 * @param {Object} props.data - データオブジェクト（data?.request.Bikouから値を取得）
 * @returns {JSX.Element} 備考コンポーネント
 */
export default function BikouArea({ form, formProps, mode = "view", data }) {
  const isViewMode = mode === "view";
  const bikouValue = data?.request?.Bikou || "";

  // 参照モードの場合
  if (isViewMode) {
    return (
      <s.DetailTable>
        <s.DetailCaption>備考</s.DetailCaption>
        <tbody>
          <tr>
            <s.DetailTd style={{ whiteSpace: "pre-line" }}>{bikouValue}</s.DetailTd>
          </tr>
        </tbody>
      </s.DetailTable>
    );
  }

  // formProps.input_Bikouが存在しない場合は直接textareaをレンダリング
  return (
    <s.DetailTable>
      <s.DetailCaption>備考</s.DetailCaption>
      <tbody>
        <tr>
          <s.DetailTd>
            <textarea name="data[request][Bikou]" style={{ width: "100%", whiteSpace: "pre-line" }} defaultValue={bikouValue} />
          </s.DetailTd>
        </tr>
      </tbody>
    </s.DetailTable>
  );
}
